import {Box, styled} from '@mui/material';
import {StyledBoxProps} from './types';

const StyledBox = styled(Box)<StyledBoxProps>`
	margin-top: auto;

	${({theme}) => theme.breakpoints.down('sm')} {
		margin-bottom: ${({$isLastStep}) => ($isLastStep ? 98 : 0)}px;
	}

	${({theme}) => theme.breakpoints.between('md', 'lg')} {
		margin-bottom: ${({$isLastStep, $adjustFooterMargin}) =>
			$isLastStep || $adjustFooterMargin ? 0 : 56}px;
	}
`;

const StyledContent = styled(Box)`
	padding-inline: 16px;
	padding-bottom: 16px;
	height: 100%;
	overflow: auto;
`;

export {StyledBox, StyledContent};
